import { Navigate, Route, Routes } from "react-router";
import { Layout } from "./components/Layout";
import { Ausgaben } from "./pages/Ausgaben";
import { Buchungen } from "./pages/Buchungen";
import { Dokument } from "./pages/Dokument";
import { Uebersicht } from "./pages/Uebersicht";
import { Firma } from "./pages/Firma";
import { Firmen } from "./pages/Firmen";
import { Login } from "./pages/Login";
import { Passkeys } from "./pages/Passkeys";
import { Rechnungen } from "./pages/Rechnungen";
import { Regeln } from "./pages/Regeln";
import { Verlauf } from "./pages/Verlauf";
import { Verrechnung } from "./pages/Verrechnung";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route index element={<Uebersicht />} />
        <Route path="/buchungen" element={<Buchungen />} />
        <Route path="/rechnungen" element={<Rechnungen />} />
        <Route path="/rechnungen/:id" element={<Dokument />} />
        <Route path="/firmen" element={<Firmen />} />
        <Route path="/firmen/:id" element={<Firma />} />
        <Route path="/kunden" element={<Navigate to="/firmen" replace />} />
        <Route path="/ausgaben" element={<Ausgaben />} />
        <Route path="/ausgaben/verrechnung" element={<Verrechnung />} />
        <Route path="/ausgaben/regeln" element={<Regeln />} />
        <Route path="/verlauf" element={<Verlauf />} />
        <Route path="/passkeys" element={<Passkeys />} />
        <Route path="*" element={<p className="text-muted-foreground">Seite nicht gefunden.</p>} />
      </Route>
    </Routes>
  );
}
